import request from '@/utils/request'
const apiPath = '/cust/userStore'
import { downloadBlob } from '@/utils/download'
const userStoreApi = {
  /**
   * 新增【活动营销】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【活动营销】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【活动营销】
   */
  fetchList(query) {
    return request.get(apiPath + '/page', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【活动营销】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  getUserStoreByCustomerId(id) {
    return request.get(`${apiPath}/getUserStoreByCustomerId/${id}`)
  },
}
export default userStoreApi

